<template>


    <div id="app">
        <div class="sectiontabs find cf">
            <ul class='tabs' data-tab>
                <li class="tab-title" v-bind:class="{ active: (mainType == 'products') }"><a
                        v-on:click="showProductSearch()">Products</a>
                </li>
                <li class="tab-title" v-bind:class="{ active: (mainType == 'retailers') }"><a
                        v-on:click="showRetailerSearch()">Retailers</a>
                </li>
            </ul>
        </div>
        <div class="resultswrap">


            <transition name="fade">
                <div v-if="(mainType == 'products')" class="searchrow cf">


                    <div class="searchrow cf">
                        <h4>Search for a Non-GMO Project Verified Product by:</h4>

                        <form class='filterbar' action="" method="get" @submit.prevent="find_brands_by_keyword">
                            <div class='findbuttonrow clearfix'>
                                <div class="findbutton"
                                     v-bind:class="{ active: (productDisplayState == 'categories') }">
                                    <a href="#" v-on:click="browse_cats()">Browse Product Categories</a>
                                </div>
                                <div class="findbutton"
                                     v-bind:class="{ active: (productDisplayState == 'browsebrands') }">
                                    <a href="#" v-on:click="browse_brands()">Browse Brands & Products</a>
                                </div>
                                <div class='findbutton searchrow clearfix '>
                                    <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                                           type="text" class='keyword' name="keyword" placeholder="Keyword Search"
                                           value="" v-model.lazy="keyword"/>
                                    <span class="fa fa-search" v-on:click="find_brands_by_keyword()"></span>
                                </div>
                            </div>
                        </form>
                    </div>

                    <transition name="fade">
                        <Categories v-if="(productDisplayState == 'categories')" :key="componentKey"/>
                    </transition>

                    <transition name="fade">
                        <Brands v-if="(productDisplayState == 'browsebrands')" v-bind:brand_id="brand_id" :key="brandsKey" />
                    </transition>

                    <transition name="fade">
                        <BrandsProductsByKeyword v-if="(productDisplayState == 'keyword')" v-bind:keyword="keyword" :key="brandsProductsKey"/>
                    </transition>

                </div>
            </transition>



            <transition name="fade">
                <div v-if="(mainType == 'retailers')" class="searchrow cf">

                    <Retailers/>

                </div>
            </transition>


        </div>
    </div>
</template>

<script>
    import Retailers from './components/Retailers.vue'
    import Brands from './components/Brands.vue'
    import Categories from './components/Categories.vue'
    import BrandsProductsByKeyword from './components/BrandsProductsByKeyword.vue'

    export default {
        name: 'app',
        components: {
            Categories,
            Retailers,
            Brands,
            BrandsProductsByKeyword
        },
        data() {
            return {
                brandsKey: 0,
                brandsProductsKey: 0,
                brand_id: 0,
                productDisplayState: 'categories',
                keyword: '',
                mainType: 'products',
                componentKey: 0, // http://michaelnthiessen.com/force-re-render/
            }
        },
        created: function() {
            this.mainType = (this.$route.query.type) ? this.$route.query.type : 'products';
            this.productDisplayState = (this.$route.query.subtype) ? this.$route.query.subtype : 'categories';
            this.brand_id = (this.$route.query.brand_id);
            if (this.brand_id) {
                this.productDisplayState = 'browsebrands';
            }
        },
        methods: {
            reset_querystring() {
                this.$router.push({ query: null });
                this.brand_id = 0;
                this.brandsKey++;
                this.brandsProductsKey++;
            },
            browse_brands() {
                this.reset_querystring();
                this.productDisplayState = 'browsebrands';
            },
            browse_cats() {
                this.reset_querystring();
                this.productDisplayState = 'categories';
                this.componentKey += 1;
            },
            find_brands_by_keyword() {
                this.reset_querystring();
                this.productDisplayState = 'keyword';
            },
            showProductSearch() {
                this.reset_querystring();
                this.mainType = 'products';
            },
            showRetailerSearch() {
                this.reset_querystring();
                this.mainType = 'retailers';
            }

        },
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
    }

    .loading {
        text-align: center;
        margin: 1em auto;
    }
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #04789F;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }

    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

    .loading.min {
        text-align: center;
        margin: 0em auto;
    }


    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }


</style>
